import React from "react";
import { ButtonBase, Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core';
import { abrirDetachedWindow} from "./helper";
import { IconNovedad, api } from "@portal/arq-portal-core"
import Image from 'material-ui-image';
const apiMeInteresa = "/MeInteresa/Imagen/?id=";
const useEstilos = makeStyles(() => ({
    slideContainer: {
        display: 'block',
        justifyContent: "start",
        width: "100%",
        position: 'relative',
        '& > div': {
            width: "100%",
            height: "180px",
            paddingTop: '0 !important',
            '@media screen and (max-width: 767px)': {
                height: "180px"
            },
            '& > img': {
                height: 'inherit !important'
            }
        },
        '& .slideTitleWrapper': {
            bottom: '0px',
            left: '0px',
            position: 'absolute',
            height: '130px',
            width: '100%',
            backgroundImage: 'linear-gradient(rgba(96,96,96,0), rgba(96,96,96,1))',
            '& .slideTitle': {
                color: '#fff', 
                padding: '6px 25px',
                fontSize: '16px',
                textAlign: 'left',
                fontFamily: 'CO-Bold',
                position: 'absolute',
                bottom: '15px',
            },
        },
    },
    bannerNovedad: {
        '& .slideTitleWrapper .slideTitle': {
            fontWeight: 'bold',
            color: '#fff !important',
            paddingRight: '30px'
        }        
    },
    novedad: {
        color: '#fff !important',
        position: 'absolute',
        right: '5px',
        top: '5px',
    }
}));

export default function Banner(props: { publicacion: any, defaultImage: any, tipo?: string }) {
    const pub = props.publicacion;
    const clases = useEstilos(props);
    return(
        <ButtonBase className={`${clases.slideContainer} ${pub.Novedad && clases.bannerNovedad}`} onClick={()=>abrirDetachedWindow(pub.UrlBase)}>
            <Image alt={pub.Titulo}
                src={api.getApiServer() + apiMeInteresa + pub.Imagen + "&tipo=" + (props.tipo ?? "BD")}
                loading={props.defaultImage}
                errorIcon={props.defaultImage}
                cover={true}
            />
            <div className="slideTitleWrapper" >
                <Typography className="slideTitle" title={pub.Titulo}>{pub.Titulo}{pub.Novedad ? <IconNovedad className={clases.novedad} /> : ""}</Typography>
            </div>
        </ButtonBase >
    ) 
}